import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { HiOutlineArrowLeft } from 'react-icons/hi'
import useResponsive from 'utils/hooks/useResponsive'

/* --------------------------------------------------------------------------
 * TicketTopbar — el boton de volver al Inbox, solo en mobile.
 *
 * Desktop: no renderiza nada (el aside lateral ya muestra siempre el #ID y
 * el estado del ticket; no hace falta una mini-bar sticky redundante).
 *
 * Mobile: flota arriba a la izquierda, fuera del flujo. Antes era una fila
 * completa con borde inferior, y en una pantalla donde lo que escasea es el
 * alto le comia una franja al contenido para decir una sola cosa. Flotando, el
 * contenido arranca mas arriba y la flecha sigue estando despues de scrollear,
 * que es cuando de verdad se busca volver.
 *
 * Queda solo el icono. El destino lo dice el `aria-label`, asi que quien usa
 * lector de pantalla sigue escuchando a donde vuelve.
 *
 * `top-[72px]`: el header del template es `sticky top-0` y mide `h-16` (64px),
 * asi que abajo quedan 8px de aire. `z-20` la deja sobre el contenido y debajo
 * del header (`z-40`), que es quien tiene que ganar si se cruzan.
 * -------------------------------------------------------------------------- */
const TicketTopbar = () => {
    const { t }       = useTranslation()
    const navigate    = useNavigate()
    const { smaller } = useResponsive()
    const isMobile    = smaller.md

    if (!isMobile) return null

    return (
        <button
            type="button"
            onClick={() => navigate('/tickets/inbox')}
            className="fixed top-[72px] left-3 z-20 flex items-center justify-center w-11 h-11 rounded-full bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 shadow-md text-gray-600 dark:text-gray-200 hover:text-indigo-600 dark:hover:text-indigo-300 active:scale-[0.97] transition-all"
            aria-label={t('back_to_inbox', 'Volver al inbox')}
        >
            <HiOutlineArrowLeft className="w-5 h-5" />
        </button>
    )
}

export default TicketTopbar
